<template>
  <v-dialog v-model="loadingDialog" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text class="p-3">
        {{ message ? message : 'Loading Data...' }} <br />
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoadingDialog.vue',
  props: {
    message: String,
    loadingDialog: Boolean,
  },
};
</script>

<style scoped></style>
